/*
Start of global snippet: Please do not remove
Place this snippet between the <head> and </head> tags on every page of your site.
Global site tag (gtag.js) - Google Marketing Platform
 */

let script = document.createElement('script');
script.src = "https://www.googletagmanager.com/gtag/js?id=DC-12104186";
document.body.append(script); // (*)

window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());

gtag('config', 'DC-12104186');

// End of global snippet: Please do not remove

/*
Event snippet for ENG_ResultadoCompruebaFibra_2022-06-07 on : Please do not remove.
Place this snippet on pages with events you’re tracking.
Creation date: 06/08/2022
 */
gtag('event', 'conversion', {
    'allow_custom_scripts': true,
    'send_to': 'DC-12104186/gurbt0/eng_r0+standard'
});
// End of event snippet: Please do not remove